import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: { label: string; to: string };
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  action,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6 md:mb-8">
      <div>
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-accent-400 mb-2">
            <span className="w-4 h-px bg-accent-500"></span>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">
          {title}
        </h2>
        {description && (
          <p className="mt-1.5 text-sm text-foreground-500 max-w-2xl">
            {description}
          </p>
        )}
      </div>
      {action && (
        <Link
          to={action.to}
          className="inline-flex items-center gap-1 text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap shrink-0"
        >
          {action.label}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}